if (!customElements.get('epic-cart-upsell')) {
  customElements.define('epic-cart-upsell', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('change', (event) => {
        if (!event.target.matches('select[name="id"]')) return;
        const option = event.target.selectedOptions[0];
        this.querySelector('[data-upsell-price]').textContent = option.dataset.price;
        const compare = this.querySelector('[data-upsell-compare]');
        compare.textContent = option.dataset.compare;
        compare.hidden = !option.dataset.compare;
        const saving = this.querySelector('[data-upsell-save]');
        if (saving) { saving.textContent = option.dataset.save || ''; saving.hidden = !option.dataset.save; }
      });
      this.querySelector('form').addEventListener('submit', async (event) => {
        const drawer = document.querySelector('cart-drawer');
        if (!drawer?.renderContents) return;
        event.preventDefault();
        const button = this.querySelector('button');
        if (button.disabled) return;
        const error = this.querySelector('[role="alert"]');
        button.disabled = true; button.textContent = 'Adding…'; error.hidden = true;
        const data = new FormData(event.target);
        data.append('sections', drawer.getSectionsToRender().map(section => section.id).join(','));
        data.append('sections_url', window.location.pathname);
        drawer.setActiveElement(document.getElementById('cart-icon-bubble'));
        try {
          const response = await fetch(window.routes.cart_add_url, { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: data });
          const state = await response.json();
          if (!response.ok || state.status) throw new Error(state.description || state.message || 'Unable to add this item. Please try again.');
          drawer.classList.remove('is-empty');
          drawer.renderContents(state);
          drawer.querySelector('.drawer__header .drawer__close')?.focus();
        } catch (failure) {
          error.textContent = failure.message || 'Unable to add this item. Please try again.';
          error.hidden = false;
        } finally { button.disabled = false; button.textContent = 'Add to cart'; }
      });
    }
  });
}
